module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starFull@2x-5d66f019a0aeca222cebc664379431de.png";